import BaseService from '@/ecm/common/BaseService.js';

class AuditService {
  baseUrl = 'audit';

  getGrid = (paginationSettings) => BaseService.post({ url: `${this.baseUrl}/get-grid`, data: paginationSettings });
  getTypes = () => BaseService.get({ url: `${this.baseUrl}/types` });
  getSources = () => BaseService.get({ url: `${this.baseUrl}/sources` });
}

export default new AuditService();
